import React, { FC, useState } from 'react';
import dayjs from 'dayjs';
import { Button, Divider, Form, Grid, Header, Icon, Input, Item, Message } from 'semantic-ui-react'
import { useDispatch, useSelector } from 'react-redux';
import { postCreditService as postCreditServiceAction, postCreditServiceInit } from '../../../../store/postCreditService/action'
import Breadcrumb from '../../../../components/breadcrumb/breadcrumb';
import { getMediumDataInit } from '../../../../store/getMediumData/action';
import { DiscountValueInterface, getQuickDiscountValues } from '../../../../interfaces/discountValue';

const EnterAmountWidget: FC<any> = () => {
    const dispatch = useDispatch();
    const [creditAmount, setCreditAmount] = useState('');
    const mediumData = useSelector((state: any) => state.getMediumData);
    const postCreditService = useSelector((state: any) => state.postCreditService);
    const userData = useSelector((state: any) => state.auth.user);
    const discountValues: DiscountValueInterface[] = getQuickDiscountValues(userData);
    const isManualDiscountEnabled = Boolean(userData?.manualDiscountEnabled);

    // digits and a single comma with at most two decimals, e.g. "1,2,3" -> "1,23"
    const sanitizeAmount = (value: string): string => {
        const [euros, ...decimals] = value.replace(/[^\d,]/g, '').split(',')
        return decimals.length ? `${euros},${decimals.join('').slice(0, 2)}` : euros
    }

    const toCent =(amount: string): number => Math.round(parseFloat(amount.replace(/,/g, ".")) * 100)

    const submitCreditAmount = (amount: string, returnToSearch: boolean = false) => {
        dispatch(postCreditServiceAction(mediumData.data.mediumNumber, toCent(amount), returnToSearch, mediumData.data.searchTerm))
    }

    const pressPostCreditService = () => submitCreditAmount(creditAmount)
    const isCreditAmountValid = toCent(creditAmount) > 0
    const isSubmitDisabled = !isCreditAmountValid || postCreditService.pending

    const pressDiscountValueButton = (formattedValue: string) => {
        submitCreditAmount(formattedValue, true)
    }

    const pressNewMediumButton = () => {
        dispatch(getMediumDataInit());
        dispatch(postCreditServiceInit());
    }

    return (
        <div>
            <Breadcrumb backButtonFunc={pressNewMediumButton} />
            <Form loading={postCreditService.pending}>
                <Grid>
                    <Grid.Column mobile={16} tablet={8} computer={8}>
                        <Header as='h3'>{`Medium ${mediumData.data.searchTerm}`}</Header>
                        <br />
                        <Item.Group>
                            <Item>
                                <Item.Content style={{ flex: 1 }}>Einfahrt</Item.Content>
                                <Item.Content style={{ flex: 2 }}>{dayjs(mediumData.data.entranceDate).format('DD.MM.YYYY, HH:mm [Uhr]')}</Item.Content>
                            </Item>
                            <Item>
                                <Item.Content style={{ flex: 1 }}>Zone</Item.Content>
                                <Item.Content style={{ flex: 2 }}>{mediumData.data.currentZoneName}</Item.Content>
                            </Item>
                            <Item>
                                <Item.Content style={{ flex: 1 }}>Parkartikel</Item.Content>
                                <Item.Content style={{ flex: 2 }}>{mediumData.data.parkingArticle}</Item.Content>
                            </Item>
                        </Item.Group>
                    </Grid.Column>
                    <Grid.Column mobile={16} tablet={8} computer={8}>
                            <Header as='h3'>Befreiung</Header>
                            {discountValues.length > 0 && (
                                <>
                                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '0.5em' }}>
                                    {discountValues.map(({ discountValue, label }, i) => {
                                        const formattedValue = Number(discountValue).toFixed(2).replace('.', ',');
                                        return (
                                            <Button
                                                key={i}
                                                type='button'
                                                style={{ margin: 0, height: '48px', color: '#fff', backgroundColor: '#346BBB' }}
                                                disabled={postCreditService.pending}
                                                onClick={() => pressDiscountValueButton(formattedValue)}
                                            >
                                                {label || `${formattedValue} €`}
                                            </Button>
                                        );
                                    })}
                                </div>
                                {isManualDiscountEnabled && <Divider horizontal style={{ margin: '2em 0' }}>oder</Divider>}
                                </>
                            )}
                            {!isManualDiscountEnabled && discountValues.length === 0 && (
                                <Message icon size='small'>
                                    <Icon name='info circle' style={{ fontSize: '1.5em', alignSelf: 'flex-start' }} />
                                    <Message.Content>
                                        Für Ihren Benutzer sind keine Befreiungsbeträge hinterlegt. Bitte wenden Sie sich an Ihren Administrator.
                                    </Message.Content>
                                </Message>
                            )}
                            {isManualDiscountEnabled && <div style={{ padding: '1em', backgroundColor: '#F7F8FA', border: '1px solid rgba(34, 36, 38, 0.15)', borderRadius: '8px' }}>
                                <label htmlFor='creditAmount' style={{ display: 'block', marginBottom: '0.5em', fontWeight: 'bold' }}>Betrag</label>
                                <div style={{ display: 'flex', gap: '0.5em' }}>
                                    <Input
                                        id='creditAmount'
                                        style={{ flex: 1, minWidth: 0 }}
                                        input={{ style: { width: 0, minWidth: 0, flex: '1 1 auto' } }}
                                        label={{ basic: true, content: '€' }}
                                        labelPosition='right'
                                        placeholder='0,00'
                                        value={creditAmount}
                                        onChange={(e) => setCreditAmount(sanitizeAmount(e.target.value))}
                                    />
                                    <Button
                                        type='submit'
                                        style={isSubmitDisabled ? { margin: 0 } : { margin: 0, color: '#fff', backgroundColor: '#346BBB' }}
                                        disabled={isSubmitDisabled}
                                        onClick={pressPostCreditService}
                                    >
                                        Befreien
                                    </Button>
                                </div>
                            </div>}
                    </Grid.Column>
                </Grid>
            </Form>
        </div>
    )
}

export default EnterAmountWidget;
